<template lang="pug">
.sidebars
  .sidebar.right
    button.btn.close-btn(data-action='close' data-side='right' name='chat' @click='closeView')
      span
        i.fa.fa-times-circle.fa-lg(aria-hidden='true')
    p.chattitle {{inquiry_title}}&nbsp;-&nbsp;{{client_name}}
    #chat-frame
      div.chat-inframe
        .chat-area(v-for='(message, index) in messages')
          // クライアント
          p.chat-talk(v-show='!message.user_id')
            span.talk-icon
              img(:src='message.clientSrc')
            small &nbsp;{{message.created_at}}
            pre
              span.talk-content &nbsp;{{message.text}}
            a.myattachments(v-show='message.file_name') &nbsp;{{message.file_name}}
          // ユーザ（会社）
          p.chat-talk.client(v-show='message.user_id')
            span.talk-icon.company
              i.fa.fa-building-o(aria-hidden='true')
            small &nbsp;{{message.created_at}}
            pre
              span.talk-content &nbsp;{{message.text}}
            a.myattachments &nbsp;{{message.file_name}}
        .return-chat
          router-link(:to="{ name: 'chat', params: { id: this.inquiry_id } }" target='_blank').customsmallbutton.btn.btn-success 返信
</template>

<script>
import $ from 'jquery'
import bus from '@/service/EventBus'
import Request from '@/service/Request'

export default {
  name: 'dashborad',
  data () {
    return {
      inquiry_id: '',
      inquiry_title: '',
      client_name: '',
      messages: []
    }
  },
  mounted () {
    bus.$emit('select_menu', 'message')

    // 履歴表示ボタン押下時に発火
    bus.$on('inquiry_id', (inquiryId) => {
      // 画面表示時に前のデータが見えるので、一旦display:noneする
      $('.chattitle').css('display', 'none')
      $('.chat-inframe').css('display', 'none')
      this.inquiry_id = inquiryId
      this.bind()
    })
  },
  methods: {
    // データバインド
    bind () {
      Request.create(true).get('/message/' + this.inquiry_id + '/history')
        .then((res) => {
          this.inquiry_title = res.data.inquiry.title
          this.client_name = res.data.inquiry.client_name
          // クライアントの頭文字を取得
          let fClient = res.data.inquiry.client_name.charAt(0)
          // message情報にアイコン用srcを付与する
          for (let key in res.data.messages) {
            res.data.messages[key].clientSrc = 'http://placehold.jp/28/1abb9c/333333/50x50.png?text=' + fClient
          }
          this.messages = res.data.messages
          // 表示するデータが揃ったらshow
          this.$nextTick(() => {
            $('.chattitle').css('display', '')
            $('.chat-inframe').css('display', '')
          })
        })
    },
    closeView () {
      $('.sidebar.right').trigger('sidebar:close')
    }
  }
}
</script>

<style lang="stylus" scoped>
p.chattitle
  float: right
  color: #999
.sidebar.right
  right: 0
  bottom: 0
  width: 530px
  height: 98%
  z-index: 100
  background: #2a3f54
.sidebars > .sidebar
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.64)
  position: fixed
  color: #000
  padding: 5px 26px
  font-size: 2em
  text-align: left
  .close-btn
    padding: 0
    .fa.fa-times-circle
      color: #f00
      font-size: 160% !important
.chat-inframe
  height: 80%
  overflow: auto
  padding: 0 10px
.chat-talk
  overflow: hidden
  margin: 0 0 1em 0
  padding: 0
  span
    display: block
    margin: 0
    padding: 0
  .company
    border-radius: 30px
    background-color: #ff0076
    .fa-building-o
      font-size: 30px
      padding: 10px 13px
      border: 2px solid #fff
      border-radius: 50%
  span.talk-icon
    margin-top: 15px
  .talk-icon
    float: left
    width: auto
  .talk-content
    position: relative
    box-sizing: border-box
    width: auto
    min-height: 50px
    border-radius: 10px
    background-color: #fff
    margin: 0 auto 0 20px
    padding: 1em
  .talk-icon img
    max-width: 100%
    height: auto
    vertical-align: bottom
    border: 2px solid #fff
    border-radius: 50%
  .talk-content:before
    position: absolute
    top: 15px
    left: -20px
    display: block
    width: 0
    height: 0
    content: ''
    border: 10px solid transparent
    border-right-color: #fff
  small
    margin-left: 20px
  &.client
    .talk-icon
      float: right
    .talk-content
      margin: 0 20px 0 auto
      color: #000
      background: #f7f7f7
      &:before
        right: -20px
        left: auto
        border-color: transparent
        border-left-color: #f7f7f7
    small
      margin-left: 240px
  .myattachments
    float: right
  .yourattachments
    float: right
    margin-right: 65px

pre
  white-space: pre-wrap
  padding: 0 !important
  border: none !important
  background: none !important
</style>



// WEBPACK FOOTER //
// MessageHistory.vue?b9a27a9c